var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:[_vm.variant, {
    'disabled': _vm.loading || _vm.disabled
  }],attrs:{"type":_vm.type,"disabled":_vm.loading || _vm.disabled},on:{"click":_vm.onClickButton}},[(_vm.loading)?_c('div',{staticClass:"loading"},_vm._l((8),function(i){return _c('div',{key:i,class:[("loading-circle loading-rotate" + i)]})}),0):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }